/**
 * @author       luis.orihuela@zumper.com (Luis Orihuela)
 * @copyright    Copyright (c) 2025, Zumper
 * @description  messages root reducer
 */

import { safeFilterActions } from '@zcode/utils'
import { messagesReducer } from './reducers'
import { whitelist } from './whitelist'

export { whitelist }
export const messages = safeFilterActions(messagesReducer, whitelist)
